<template>
  <div>
    <!-- Post -->
    <vue-headful
      :title="name + ' by ' + author.name + ' - Christine Argillet Collection'"
      :description="name + ' - ' + author.name + ' - ' + description"
    />
    <article class="post" v-if="author" data-aos="fade">
      <h2 class="title" v-html="name + ' ' + $t('artwork.by') + ' ' + author.name"></h2>
      <img :src="image" />
      <ul class="mt-6">
        <li>{{ $t('artwork.name') }} {{ name }}</li>
        <li>{{ $t('artwork.artist') }} <router-link :to="'/' + $i18n.locale + '/' + author.path">{{ author.name }}</router-link></li>
        <li>{{ $t('artwork.series') }} <ul style="display: inline">
          <li v-for="cat in categories" :key="cat.slug" style="display: inline">
            <router-link :to="'/' + $i18n.locale + '/' + cat.path" v-if="cat.path">{{cat.name}}</router-link>
          </li>
          </ul></li>
        <li>{{ $t('artwork.year') }} {{ year }}</li>
        <li>{{ $t('artwork.technique') }} {{ techniqueStr() }}</li>
        <li>{{ dimensionsStr() }}</li>
      </ul>
      <p class="mt-4" v-html="description"></p>
    </article>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Artwork",
  data() {
    return {
      name: "",
      description: "",
      image: null,
      year: "",
      technique: "",
      medium: "",
      author: "",
      categories: [],
      width: null,
      height: null
    };
  },
  methods: {
    async getArtworks() {
      let response = await axios.get(
        process.env.VUE_APP_API_URL_EN +
          "wp-json/blackdigital/v1/product/" +
          this.$route.params.id
      );
      this.name = this.$i18n.locale == "en" ? response.data.name : response.data.name_fr;
      this.description = this.$i18n.locale == "en" ? response.data.description : response.data.description_fr;
      this.image = response.data.image;
      this.year = response.data.year;
      this.technique = response.data.technique;
      this.medium = response.data.medium;
      this.author = response.data.author;
      this.categories = response.data.categories;
      this.width = response.data.width;
      this.height = response.data.height;
    },
    techniqueStr() {
      if (this.medium) {
        return this.technique + " on " + this.medium;
      } else {
        return this.technique;
      }
    },
    dimensionsStr() {
      if (this.width != 0 && this.height != 0) {
        return this.$t('artwork.dimensions2') + " " + this.height + " x " + this.width + " cm";
      } else if (this.height != 0) {
        return this.$t('artwork.dimensions1') + " " + this.height + " cm";
      }
      return "";
    }
  },
  mounted() {
    this.getArtworks();
  },
  watch: {
    $route() {
      this.getArtworks();
    },
  },
};
</script>